import { useRBACOptional } from '@/contexts/RBACContext';

/** Beta feature-access permission keys granted per user by rbac-svc (not covered by the org-owner wildcard). */
export const BETA_ACCESS = {
  logicNewDesign: 'logic.new_design',
  emailVdpRules: 'email.vdp_rules',
  voiceAgentTemplateCreate: 'voice_agent.template.create',
  blynView: 'blyn.view',
  blynViewInSubtenant: 'blyn.view_in_subtenant',
  blynSettingsTabs: 'blyn.settings_tabs',
  commandCenterView: 'command_center.view',
  designStudioEditor: 'design_studio.editor',
  impersonationUse: 'impersonation.use',
  errorCopyDetails: 'error.copy_details',
} as const;

export type BetaAccessKey = (typeof BETA_ACCESS)[keyof typeof BETA_ACCESS];

/** False while RBAC is loading or outside the provider, so gated UI stays hidden until the grant is known. */
export function useBetaAccess(code: BetaAccessKey): boolean {
  const rbac = useRBACOptional();
  return Boolean(rbac && !rbac.isLoading && rbac.hasBetaAccess(code));
}
